import React from 'react';

const FreeTextQuestionIcon = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="#FF9538" />
            <path d="M28 10.1172H12C10.897 10.1172 10 11.0142 10 12.1172V24.1172C10 25.2202 10.897 26.1172 12 26.1172H15V29.8832L21.277 26.1172H28C29.103 26.1172 30 25.2202 30 24.1172V12.1172C30 11.0142 29.103 10.1172 28 10.1172ZM28 24.1172H20.723L17 26.3512V24.1172H12V12.1172H28V24.1172Z" fill="#F8F5FD" />
            <path d="M23 20.1172C24.1046 20.1172 25 19.2218 25 18.1172C25 17.0126 24.1046 16.1172 23 16.1172C21.8954 16.1172 21 17.0126 21 18.1172C21 19.2218 21.8954 20.1172 23 20.1172Z" fill="#F8F5FD" />
            <path d="M17 20.1172C18.1046 20.1172 19 19.2218 19 18.1172C19 17.0126 18.1046 16.1172 17 16.1172C15.8954 16.1172 15 17.0126 15 18.1172C15 19.2218 15.8954 20.1172 17 20.1172Z" fill="#F8F5FD" />
        </svg>
    )
}

export default FreeTextQuestionIcon;